/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteConfigurationRequest,
  ErrorResult,
  GetConfigAllParams,
  GetConfigParams,
  ProblemDetails,
  SaveConfigurationRequest,
  UserConfiguration
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Examples:
 *     GET /Config?entityType=1
 *     GET /Config?entityType=User
 *     GET /Config?entityType=League&entityId=123
 *     GET /Config?entityType=2&entityId=123
 *
 * Admin accessing another user's config:
 *     GET /Config?userId=456&entityType=User
 * @summary Get a specific user configuration
 */
export const getConfig = (
    params?: GetConfigParams,
 signal?: AbortSignal
) => {


      return fetcher<UserConfiguration>(
      {url: `/Config`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetConfigQueryKey = (params?: GetConfigParams,) => {
    return [
    `/Config`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = ProblemDetails>(params?: GetConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = ProblemDetails


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = ProblemDetails>(
 params: undefined |  GetConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = ProblemDetails>(
 params?: GetConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = ProblemDetails>(
 params?: GetConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user configuration
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = ProblemDetails>(
 params?: GetConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new configuration or updates existing one if it already exists.
 * EntityType can be specified as integer or string name.
 *
 * Examples:
 *
 * Save current user's config using integer:
 *     PUT /Config
 *     {
 *       "entityType": 1,
 *       "entityId": null,
 *       "configurationValue": Json value here
 *     }
 *
 * Save current user's default team config using string:
 *     PUT /Config
 *     {
 *       "entityType": "Team",
 *       "entityId": null,
 *       "configurationValue": Json value here
 *     }
 *
 * Save current user's team config for team 123:
 *     PUT /Config
 *     {
 *       "entityType": 3,
 *       "entityId": 123,
 *       "configurationValue": Json value here
 *     }
 *
 * Admin saving config for another user:
 *     PUT /Config/456
 *     {
 *       "entityType": 1,
 *       "entityId": null,
 *       "configurationValue": Json value here
 *     }
 * @summary Save or update a user configuration
 */
export const putConfig = (
    saveConfigurationRequest?: SaveConfigurationRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveConfigurationRequest, signal
    },
      );
    }




export const getPutConfigMutationKey = () => ['putConfig'] as const;

export const getPutConfigMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext> => {

const mutationKey = getPutConfigMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putConfig>>, PutConfigMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putConfig(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putConfig>>>
    export type PutConfigMutationBody = SaveConfigurationRequest | undefined
    export type PutConfigMutationError = ErrorResult | ProblemDetails
    export type PutConfigMutationVariables = {data?: SaveConfigurationRequest}

    /**
 * @summary Save or update a user configuration
 */
export const usePutConfig = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putConfig>>, TError,PutConfigMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putConfig>>,
        TError,
        PutConfigMutationVariables,
        TContext
      > => {
      return useMutation(getPutConfigMutationOptions(options), queryClient);
    }
    /**
 * EntityType can be specified as integer or string name.
 *
 * Examples:
 *
 * Delete current user's config using integer:
 *     DELETE /Config
 *     {
 *       "entityType": 1,
 *       "entityId": null
 *     }
 *
 * Delete current user's config using string:
 *     DELETE /Config
 *     {
 *       "entityType": "User",
 *       "entityId": null
 *     }
 *
 * Delete current user's team config for team 123:
 *     DELETE /Config
 *     {
 *       "entityType": "Team",
 *       "entityId": 123
 *     }
 *
 * Admin deleting config for another user:
 *     DELETE /Config/456
 *     {
 *       "entityType": "User",
 *       "entityId": null
 *     }
 * @summary Delete a user configuration
 */
export const deleteConfig = (
    deleteConfigurationRequest?: DeleteConfigurationRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Config`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteConfigurationRequest, signal
    },
      );
    }




export const getDeleteConfigMutationKey = () => ['deleteConfig'] as const;

export const getDeleteConfigMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,DeleteConfigMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,DeleteConfigMutationVariables, TContext> => {

const mutationKey = getDeleteConfigMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConfig>>, DeleteConfigMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteConfig(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConfigMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConfig>>>
    export type DeleteConfigMutationBody = DeleteConfigurationRequest | undefined
    export type DeleteConfigMutationError = ErrorResult | ProblemDetails
    export type DeleteConfigMutationVariables = {data?: DeleteConfigurationRequest}

    /**
 * @summary Delete a user configuration
 */
export const useDeleteConfig = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,DeleteConfigMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConfig>>,
        TError,
        DeleteConfigMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteConfigMutationOptions(options), queryClient);
    }
    /**
 * Get all configs for current user:
 *     GET /Config/All
 *
 * Admin accessing another user's configs:
 *     GET /Config/All?userId=456
 * @summary Get all configurations for a user
 */
export const getConfigAll = (
    params?: GetConfigAllParams,
 signal?: AbortSignal
) => {


      return fetcher<UserConfiguration[]>(
      {url: `/Config/All`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetConfigAllQueryKey = (params?: GetConfigAllParams,) => {
    return [
    `/Config/All`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConfigAllQueryOptions = <TData = Awaited<ReturnType<typeof getConfigAll>>, TError = ProblemDetails>(params?: GetConfigAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigAll>>> = ({ signal }) => getConfigAll(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigAllQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigAll>>>
export type GetConfigAllQueryError = ProblemDetails


export function useGetConfigAll<TData = Awaited<ReturnType<typeof getConfigAll>>, TError = ProblemDetails>(
 params: undefined |  GetConfigAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigAll>>,
          TError,
          Awaited<ReturnType<typeof getConfigAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigAll<TData = Awaited<ReturnType<typeof getConfigAll>>, TError = ProblemDetails>(
 params?: GetConfigAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigAll>>,
          TError,
          Awaited<ReturnType<typeof getConfigAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigAll<TData = Awaited<ReturnType<typeof getConfigAll>>, TError = ProblemDetails>(
 params?: GetConfigAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all configurations for a user
 */

export function useGetConfigAll<TData = Awaited<ReturnType<typeof getConfigAll>>, TError = ProblemDetails>(
 params?: GetConfigAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigAll>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






